// Get or Create User's Art of Looking Progress
export const PROGRESS_GET_REQUEST = "PROGRESS_GET_REQUEST";
export const PROGRESS_GET_SUCCESS = "PROGRESS_GET_SUCCESS";
export const PROGRESS_GET_FAIL = "PROGRESS_GET_FAIL";

// Update a Single Module's Progress
export const PROGRESS_UPDATE_MODULE_REQUEST = "PROGRESS_UPDATE_MODULE_REQUEST";
export const PROGRESS_UPDATE_MODULE_SUCCESS = "PROGRESS_UPDATE_MODULE_SUCCESS";
export const PROGRESS_UPDATE_MODULE_FAIL = "PROGRESS_UPDATE_MODULE_FAIL";

// Record the Result of the Final Quiz
export const PROGRESS_RECORD_FINAL_QUIZ_REQUEST =
  "PROGRESS_RECORD_FINAL_QUIZ_REQUEST";
export const PROGRESS_RECORD_FINAL_QUIZ_SUCCESS =
  "PROGRESS_RECORD_FINAL_QUIZ_SUCCESS";
export const PROGRESS_RECORD_FINAL_QUIZ_FAIL =
  "PROGRESS_RECORD_FINAL_QUIZ_FAIL";
